import App, { AppProps } from './App';

/**
 * To avoid render blocking css we treat main.css as non-critical css
 * and load it after the page has been rendered
 */
export function isCriticalCss(stylePath: string) {
  return true;
}

const AppSSr = (props: AppProps) => {
  const { helmet, isMobile, bootstrapStyles = [], preload = [] } = props;
  return (
    <html lang={'sv-SE'} className={isMobile ? 'screen-mobile' : 'screen-desktop'}>
      <head>
        {preload.map((props, i) => (
          <link key={i} {...props} />
        ))}
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0,  viewport-fit=cover" />
        <link rel="shortcut icon" href="/favicon.ico" />

        <link rel="apple-touch-icon" sizes="57x57" href="/images/apple-icon-57x57.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="/images/apple-icon-60x60.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="/images/apple-icon-72x72.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="/images/apple-icon-76x76.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="/images/apple-icon-114x114.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="/images/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="/images/apple-icon-144x144.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="/images/apple-icon-152x152.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/images/apple-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="/images/android-icon-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/images/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="/images/favicon-96x96.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/images/favicon-16x16.png" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/images/ms-icon-144x144.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="apple-itunes-app" content="app-id=1449704181, affiliate-data=ct=smartbanner&pt=119648691" />

        <meta http-equiv="cache-control" content="max-age=0" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="expires" content="Tue, 01 Jan 1980 1:00:00 GMT" />
        <meta http-equiv="pragma" content="no-cache" />

        <meta name="google" content="nositelinkssearchbox" />

        {helmet?.title?.toComponent()}
        {helmet?.meta?.toComponent()}

        <link rel="preload" href="/fonts/brown-regular.woff" as="font" type="font/woff2" crossOrigin="" />
        <link rel="preload" href="/fonts/brown-bold.woff" as="font" type="font/woff2" crossOrigin="" />
        <link rel="preload" href="/fonts/gibson-regular.woff" as="font" type="font/woff2" crossOrigin="" />
        <link rel="preload" href="/fonts/gibson-bold.woff" as="font" type="font/woff2" crossOrigin="" />
        <link rel="preload" href="/fonts/gibson-semibold.woff" as="font" type="font/woff2" crossOrigin="" />
        <link rel="preload" href="/fonts/DigitalNumbers-Regular.woff" as="font" type="font/woff2" crossOrigin="" />

        <link rel="preconnect" href="https://www.googletagmanager.com" />
        <link rel="preconnect" href="https://api.amplitude.com" />
        <link rel="preconnect" href="https://cdn.bokadirekt.se" />
        <link rel="preconnect" href="https://cdn.amplitude.com" />
        <link rel="preconnect" href="https://connect.facebook.net" />
        <link rel="preconnect" href="https://pro.ip-api.com" />
        <link rel="preconnect" href="https://stats.g.doubleclick.net" />
        <link rel="preconnect" href="https://www.google.com" />
        <link rel="preconnect" href="https://www.google.se" />

        <script
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `window.dataLayer = window.dataLayer || [];
                    function gtag() {
                       dataLayer.push(arguments);
                    }
                    function getCookie(name) {
                      const cookies = document.cookie.split('; ');
                      for (const cookie of cookies) {
                        const [key, value] = cookie.split('=');
                        if (key === name) {
                          return value;
                        }
                      }
                      return false;
                    }

                   const trackingConsent = getCookie('BokadirektCookiePreferencesMP') === 'Analytics';

                   if (trackingConsent) {
                      gtag('consent', 'update', {
                        ad_user_data: 'granted',
                        ad_personalization: 'granted',
                        ad_storage: 'granted',
                        analytics_storage: 'granted',
                      });
                    } else {
                      gtag('consent', 'default', {
                        ad_user_data: 'denied',
                        ad_personalization: 'denied',
                        ad_storage: 'denied',
                        analytics_storage: 'denied',
                      });
                    }
                    gtag('js', new Date());`,
          }}
        />

        {bootstrapStyles.filter(isCriticalCss).map((style, i) => (
          <link key={i} type="text/css" rel="stylesheet" href={style} />
        ))}

        <link rel="stylesheet" id="boka-style" href="/css/web.css?123456789013" media="screen" />

        <script src="/js/no-pollution.js" />
        <script src="/js/fbpixel.js" />

        {/* scripts loaded after dom is parsed */}
        <script defer type="text/javascript" src="/js/gtag.js" />
        <script defer type="text/javascript" src="/js/cio.js" />
        <script defer type="text/javascript" src="/js/tiktokpixel.js" />
      </head>
      <body>
        <div id="root">
          <App {...props} />
        </div>
      </body>
    </html>
  );
};

export default AppSSr;
